// extracted by mini-css-extract-plugin
export default {"IframeCard-iframe":"IframeCard-iframe","IframeCard-Card":"IframeCard-Card","IframeCard-CardConfig":"IframeCard-CardConfig","IframeCard-CardContent":"IframeCard-CardContent"};